<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="back-outer">
    <p>
        <img (click)="backClicked()" src="../../../../../assets/images/fi-rr-arrow-left.svg" alt="Left" />
        <span (click)="backClicked()">Back</span>
    </p>

</div>
<div class="booking-details-box driver-information custom-details">
    <div class="information-inner">
        <div class="invoice-number">
            <h4> <span>{{bookingDetail?.companyName}}</span> - Booking Details</h4>
        </div>

        <div class="action-item">
            <p>Invoice #{{invoiceNumber}}</p>
            <div class="export-btn" (click)="showData();menu.toggle($event)">
                <span class="action-driver">Actions</span>

                <img src="assets/images/bluefull-dropdown.svg" alt="" />

</div>
        </div>
    </div>
    <div class="booking-details">
        <div class="grid">
            <div class="col-12 lg:col-7">
                <div class="grid">
                    <div class="col-12 lg:col-4">
                        <div class="booking-img">
                            <img src="{{bookingDetail?.parkingLayout  || emptyImageHolder}}" alt="booking"
                                class="img-fluid" />
                        </div>
                    </div>
                    <div class="col-12 lg:col-8">
                        <div class="details-box">
                            <div class="address-name">
                                <div class="details-values">
                                    {{bookingDetail?.parkingArea || "-"}}
                                </div>
                                <div class="details-values custom-address">
                                    {{bookingDetail?.address || "-"}}
                                </div>

                            </div>
                        </div>

                        <div class="details-box custom-details">
                            <p class="details-title">
                                Booking Created By

                            </p>
                            <div class="details-values">
                                {{ bookingDetail?.createdByType && bookingDetail?.createdByName
                                ? bookingDetail.createdByType + ' - ' + bookingDetail.createdByName
                                : (bookingDetail?.createdByType || bookingDetail?.createdByName || '-') }}
                            </div>
                        </div>
                        <div class="details-box custom-details">

                            <p class="details-title">
                                Arrival Date & Time
                            </p>
                            <div class="details-values">
                                {{(bookingDetail?.arrivalTime) || '-'}}
                            </div>
                        </div>

                        <div class="details-box custom-details">

                            <p class="details-title">
                                Departure Date & Time
                            </p>
                            <div class="details-values">
                                {{(bookingDetail?.departureTime) || "-"}}
                            </div>
                        </div>
                        <div class="details-box custom-details">
                            <p class="details-title">
                                Time Zone
                            </p>
                            <div class="details-values">
                                {{bookingDetail?.timeZone? getTimeZoneAbbreviation(bookingDetail?.timeZone): "-" }}
                            </div>
                        </div>
                        <div class="details-box custom-details status">
                            <p class="details-title">
                                Booking Type
                            </p>

                            <div class="details-values reservation-text">
                                {{bookingDetail?.bookingType === 0? 'One Time':'Reccuring'}}
                            </div>
                        </div>
                        <div class="details-box custom-details status">
                            <p class="details-title">
                                Booking Status
                            </p>
                            <div class="details-values"
                                [ngClass]="bookingDetail?.status | BookingStatusClassWithoutBorder">
                                {{bookingDetail?.status || "-"}}
                            </div>
                        </div>
                        <div class="details-box custom-details status">
                            <p class="details-title">
                                Payment Date
                            </p>
                            <div class="details-values">
                                {{ getFormattedPaymentDate() }}
                            </div>
                        </div>
                        <div class="details-box custom-details status">
                            <p class="details-title">
                                Spots
                            </p>
                            <div class="details-values">{{bookingDetail?.slotCount || "-"}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-5">
                <div class="parking-durationbox">
                    <div class="parking-duration-detailsbox">
                        <div class="parking-heading">
                            <p class="heading">
                                Parking Duration
                            </p>
                            <p class="about-heading">
                                {{bookingDetail?.duration}}
                            </p>
                        </div>
                        <div class="parking-detailsbox">
                            <div class="parking-details">
                                <p class="parking-details-title">
                                    Amount
                                </p>
                                <p class="parking-details-value">
                                    ${{bookingDetail?.amount}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.discount && bookingDetail?.discount>0" class="parking-details">
                                <p class="parking-details-title">
                                    Discount
                                </p>
                                <p class="parking-details-value">
                                    - {{bookingDetail?.discount}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.coupanAmount>0 && bookingDetail.couponDiscountPercentage >0"
                                class="parking-details">
                                <p class="parking-details-title">
                                    Coupon Discount
                                </p>
                                <p class="parking-details-value">
                                    - ${{bookingDetail?.coupanAmount}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.taxAndFees && bookingDetail?.taxAndFees>0"
                                class="parking-details">
                                <p class="parking-details-title">
                                    Taxes
                                </p>
                                <p class="parking-details-value">
                                    ${{bookingDetail?.taxAndFees}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.usedCredit>0" class="parking-details">
                                <p class="parking-details-title green-text">
                                    Credit
                                </p>
                                <p class="parking-details-value green-text">
                                    - {{bookingDetail?.usedCredit}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.transactionFees > '0.00'" class="parking-details">
                                <p class="parking-details-title">
                                    Transaction Fees
                                </p>
                                <p class="parking-details-value">
                                    ${{bookingDetail?.transactionFees}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.exemptTaxesAndFees != null && bookingDetail?.exemptTaxesAndFees > 0"
                                class="parking-details">
                                <p class="parking-details-title">
                                    Exempt Taxes And Fees
                                </p>
                                <p class="parking-details-value">
                                    -${{bookingDetail?.exemptTaxesAndFees}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.initialTotal > '0.00' && bookingDetail?.bookingSlotCountUpdateDetail !== null"
                                class="parking-details">
                                <p class="parking-details-title">Initial Amount ({{ bookingDetail?.initialSpots +(
                                    bookingDetail?.initialSpots === 1 ? ' Spot' : ' Spots')}})
                                </p>
                                <p class="parking-details-value">
                                    ${{bookingDetail?.initialTotal}}
                                </p>
                            </div>
                            <div *ngFor="let item of bookingDetail?.bookingSlotCountUpdateDetail"
                                class="parking-details">
                                <p *ngIf="item.spotUpdateType === 1 && item?.total > 0" class="parking-details-title title-tooltip">
                                    <span>Add-on Amount ({{item?.spotCount}} {{item?.spotCount === '1' ? 'Spot' :
                                        'Spots'}})</span>
                                    <span><app-tooltip [tooltipMessage]="slotUpdateTooltipTemplate"
                                            [addClass]="'custom-tooltip-width-addon'" [tooltipContext]="{ $implicit: item }"
                                            (parkingDetailsObj)="getScreenSize($event)"></app-tooltip></span>
                                </p>
                                <p *ngIf="item.spotUpdateType === 2 && item?.total > 0" class="parking-details-title title-tooltip">
                                    <span>
                                        Refunded Amount ({{item?.spotCount}} {{item?.spotCount === '1' ? 'Spot' :
                                        'Spots'}})
                                    </span>
                                    <span>
                                        <app-tooltip [tooltipMessage]="slotUpdateRefundTooltipTemplate" [tooltipContext]="{ $implicit: item }"
                                            [addClass]="'custom-tooltip-width-addon'"
                                            (parkingDetailsObj)="getScreenSize($event)"></app-tooltip>
                                    </span>
                                </p>
                                <p  *ngIf="item?.total > 0" class="parking-details-value">
                                    {{item?.spotUpdateType === 2 ? '- $' + item?.total : ' $' + item?.total}}
                                </p>
                            </div>
                            <div *ngIf="bookingDetail?.bookingCustomRefundAmount > '0.00'" class="parking-details">
                                <p class="parking-details-title icon-tooltip">
                                    Custom Refund
                                    <app-tooltip
                                    [tooltipMessage]="tooltipTableTemplate"
                                    [addClass]="'dues-tooltip-outer refund-tooltip'"></app-tooltip>
                                </p>
                                <p class="parking-details-value">
                                    - ${{bookingDetail?.bookingCustomRefundAmount}}
                                </p>
                            </div>                
                        </div>
                    </div>
                    <div class="parking-amount-box">
                        <div class="total-amount-box">
                            <h3>
                                ${{bookingDetail?.paidAmount}}
                            </h3>
                            <p class="total-amount-text"><span>{{ bookingDetail?.usedCredit > 0 ? 'Amount + Credits' :
                                    'Total Amount' }}</span>
                                <span *ngIf="bookingDetail?.usedCredit"><app-tooltip
                                        [tooltipMessage]="tooltipTemplate"
                                        [addClass]="'custom-tooltip-width-addon'"
                                        (parkingDetailsObj)="getScreenSize($event)"></app-tooltip></span>
                            </p>
                        </div>
                        <div class="details-box custom-details status payment">
                            <div class="common-tamount-text" [ngClass]="{
                                'common-tamount-in-progress':  bookingDetail?.paymentStatus === paymentStatusForMessage.Processing,
                                'common-tamount-payment-failed': bookingDetail?.paymentStatus ===  paymentStatusForMessage.PaymentLinkExpire || bookingDetail?.paymentStatus === paymentStatusForMessage.Failure || bookingDetail?.paymentStatus ===  paymentStatusForMessage.DisputeCreated || bookingDetail?.paymentStatus ===  paymentStatusForMessage.DisputeExpired || bookingDetail?.paymentStatus ===  paymentStatusForMessage.DisputeLoss || bookingDetail?.paymentStatus ===  paymentStatusForMessage.DisputeUpdated,
                                'common-tamount-cancel': bookingDetail?.paymentStatus ===  paymentStatusForMessage.Cancelled,
                                'common-tamount-paid': bookingDetail?.paymentStatus === paymentStatusForMessage.Completed ||  bookingDetail?.paymentStatus === paymentStatusForMessage.PartialCancel || paymentStatusForMessage.RecurringPendingPayment,
                                'common-tamount-pending': bookingDetail?.paymentStatus === paymentStatusForMessage.Pending || bookingDetail?.paymentStatus === paymentStatusForMessage.InvoiceGenerated || bookingDetail?.paymentStatus === paymentStatusForMessage.CheckoutUrlGenrated
                               || bookingDetail?.paymentStatus === paymentStatusForMessage.PendingWithOffline|| bookingDetail?.paymentStatus ===  paymentStatusForMessage.PaymentLinkExpire,
                            }">
                                {{bookingDetail?.bookingStatus?.label}}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="payment-error" *ngIf="bookingDetail?.paymentFailureError != null">
            <p><strong>Payment Failed Reason: </strong><span>{{bookingDetail?.paymentFailureError}}</span></p>
        </div>
    </div>

    <div *ngIf="!bookingDetail?.isOpenGateIntegarted && !paymentStatusCheck && bookingDetail?.status !== 'Cancelled'  && bookingDetail?.status !== 'Completed'"
        class="access-codebox">
        <p class="access-heading">
            Access Code
        </p>
        <div class="qr-wrapper">
            <div class="qr-outer">
                <div class="access-codes">
                    <ul>
                        <li *ngFor="let char of (bookingDetail?.accessCode?.split('') || [])">
                            <span>
                                {{ char }}&nbsp; 
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="share-btnbox">
                <a class="share-btn" (click)="getChechInOutDetails()">
                    <span class="icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.89058 11.1094C9.1208 11.3396 9.49406 11.3396 9.72428 11.1094L19.8273 1.00637C20.0575 0.776147 20.0575 0.402886 19.8273 0.172665C19.5971 -0.0575551 19.2238 -0.0575551 18.9936 0.172665L8.89058 10.2757C8.66036 10.5059 8.66036 10.8792 8.89058 11.1094Z"
                                fill="#1E4FD8" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.0612 18.6714C11.2859 19.4578 12.0046 20 12.8225 20C13.6409 20 14.3626 19.4632 14.5977 18.6793L19.9751 0.75493C19.9751 0.754823 19.9753 0.754283 19.414 0.585915C19.2457 0.0246903 19.2456 0.0247063 19.2455 0.0247385L1.32064 5.40222C0.536759 5.63735 0 6.3588 0 7.17712C0 7.99502 0.542135 8.71403 1.32852 8.93872C2.44973 9.25907 4.42045 9.82213 6.11087 10.3051L8.89841 11.1016L9.69485 13.8891C10.1778 15.5795 10.7409 17.5502 11.0612 18.6714ZM9.37238 10.6276C9.53335 10.0642 9.53332 10.0642 9.53328 10.0642L6.36515 9.159C4.69007 8.6804 2.75675 8.12802 1.65046 7.81193C1.36716 7.73099 1.17187 7.47211 1.17187 7.17743C1.17187 6.87662 1.36918 6.61112 1.65733 6.52468L18.5401 1.45983L13.4753 18.3426C13.3889 18.6308 13.1237 18.8281 12.8228 18.8281C12.5282 18.8281 12.269 18.6328 12.188 18.3495C11.8719 17.2432 11.3196 15.3099 10.841 13.6348L9.93584 10.4669C9.93583 10.4668 9.93577 10.4666 9.37238 10.6276ZM9.37238 10.6276L9.93584 10.4669C9.88023 10.2722 9.72793 10.1198 9.53328 10.0642L9.37238 10.6276ZM19.414 0.585915L19.2455 0.0247385C19.452 -0.0372026 19.6759 0.0191738 19.8284 0.171595C19.9808 0.324016 20.037 0.548466 19.9751 0.75493L19.414 0.585915Z"
                                fill="#1E4FD8" />
                        </svg>
                    </span>
                    Share
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="bookingDetail?.licenseNumberPlate" class="veh-information">
        <h4>{{equipmentMsg}}</h4>
        <div class="veh-table">
            <p-table [tableStyle]="{ 'min-width': '50rem' }" [resizableColumns]="true" columnResizeMode="expand">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="veh-type" scope="col">{{spotTypeMsg}}</th>
                        <th class="lice-number" scope="col">License Plate Number</th>
                        <th class="mc-number" scope="col">DOT Number </th>
                        <th class="mc-number" scope="col">VIN Number </th>
                        <th class="make-outer" scope="col">Make</th>
                        <th scope="col">Color</th>
                    </tr>

                    <tr>
                        <td>
                            <div class="common-head">
                                <img [ngClass]="{'borderClass': bookingDetail?.vehicleImage}"
                                    [src]="bookingDetail?.vehicleImage ? bookingDetail.vehicleImage : bookingDetail?.vehicleTypeImagePath"
                                    alt="booking" />
                                <div class="common-heading">
                                    <h5>{{bookingDetail?.vehicleType || '-'}}</h5>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="common-heading">
                                <h5>{{bookingDetail?.licenseNumberPlate || '-'}}</h5>
                            </div>
                        </td>
                        <td>
                            <div class="common-heading last-td">
                                <h5>{{bookingDetail?.dotNumber || '-'}}</h5>
                            </div>
                        </td>
                        <td>
                            <div class="common-heading last-td">
                                <h5>{{bookingDetail?.vinNumber || '-'}}</h5>
                            </div>
                        </td>
                        <td>
                            <div class="common-heading">
                                <h5>{{bookingDetail?.make || '-'}}</h5>
                            </div>
                        </td>
                        <td>
                            <div class="common-heading">
                                <h5>{{bookingDetail?.color || '-'}}</h5>
                            </div>
                        </td>

                    </tr>

                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="partial-outer" *ngIf="bookingDetail?.isCancelled && bookingDetail?.paymentStatus != 5">
        <div class="booking-cancel">
            <h3 class="access-heading">
                Booking Cancelled
            </h3>
            <p>
                The booking has been cancelled by the {{ bookingDetail?.cancelledBy }}<span>{{
                  isBookingCancelledCheck
                    ? (!bookingCancelWithRefundCheck ? '.' : ', and a refund has been initiated to the original payment method.')
                    : '.'
                }}</span>
              </p>
            <div *ngIf="bookingDetail?.bookingType === 2" class="reason-outer">
                <p><strong>Reason for Cancellation:</strong></p>
                <p>
                    {{ bookingDetail.cancellationReason }}
                    <ng-container *ngIf="bookingDetail.cancellationReasonDetail">
                        - {{ bookingDetail.cancellationReasonDetail }}
                    </ng-container>
                </p>
            </div>
        </div>
        <div *ngIf="refundAmountCheck" class="refunded-outer">
            <h4>${{bookingDetail?.refundableAmount }}</h4>
            <p>{{ 'Refundable Amount' + (bookingDetail?.usedCredit > 0 ? ' + Credits' : '')}}</p>
        </div>
    </div>
    <div class="booking-survey-feedback" *ngIf="getSelectedRating(bookingDetail?.parkingExperinceRating) as rating">
        <h4>Survey Feedback</h4>
        <div class="recommend-outer">
            <div class="recommend-left">
                <img [src]="rating?.emoji" alt="" />
                 <p><strong>{{rating?.label}} : </strong>{{rating?.desc}}</p>

            </div>
            <div class="date-feedback">
                <h5>Date of feedback</h5>
                <p>{{bookingDetail?.surveySubmittedDate}}</p>
            </div>
        </div>
    </div>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
<ng-template #tooltipTemplate>
    <div class="tooltip-inner-text">
        <p>
          <span>Amount</span>
          <span>${{ bookingDetail?.total1 }}</span>
        </p>
      
        <p>
          <span>Credit</span>
          <span>{{ bookingDetail?.usedCredit }}</span>
        </p>
      
        <p *ngIf="bookingDetail?.partialCancelAmount > 0">
          <span>Refund</span>
          <span>-${{ bookingDetail?.partialCancelAmount }}</span>
        </p>
      
        <p *ngIf="bookingDetail?.bookingCustomRefundAmount > 0">
          <span>Custom Refund</span>
          <span>-${{ bookingDetail?.bookingCustomRefundAmount }}</span>
        </p>
      </div>
</ng-template>
<ng-template #tooltipTableTemplate>
    <div class="dues-table" *ngIf="bookingDetail">
      <ng-container *ngIf="bookingDetail.bookingCustomRefundAmount > 0">
        <div class="dues-heading">
          <h5>Refund Reason</h5>
          <p>{{ getReasonText(bookingDetail.customRefundReason) }}</p>
        </div>
        <div class="table-body">
          <h5>Refund Note</h5>
          <p>{{ bookingDetail.customRefundReasonAdditionalNote }}</p>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #slotUpdateTooltipTemplate let-item>
    <div class="tooltip-heading">
      <h5>Add-on</h5>
      <p>On {{ item?.updateDate }}</p>
    </div>
  
    <div class="tooltip-inner-text">
      <p>
        <span>Spot Count</span>
        <span>{{ item?.spotCount }}</span>
      </p>
      <p>
        <span>Amount</span>
        <span>{{ item?.amount | currency:'USD' }}</span>
      </p>
      <p>
        <span>Taxes</span>
        <span>{{ item?.taxAndFees | currency:'USD' }}</span>
      </p>
      <p>
        <span>Fees</span>
        <span>{{ item?.transactionFees | currency:'USD' }}</span>
      </p>
    </div>
  
    <div class="dotes-border">
      <p>
        <span>Total add-on</span>
        <span>{{ item?.total | currency:'USD' }}</span>
      </p>
    </div>
  </ng-template>
  <ng-template #slotUpdateRefundTooltipTemplate let-item>
    <div class="tooltip-heading">
      <h5>Reduced</h5>
      <p>On {{ item?.updateDate }}</p>
    </div>
  
    <div class="tooltip-inner-text">
      <p>
        <span>Spot Count</span>
        <span>{{ item?.spotCount }}</span>
      </p>
      <p>
        <span>Amount</span>
        <span>{{ item?.total | currency:'USD' }}</span>
      </p>
    </div>
  
    <div class="dotes-border">
      <p>
        <span>Total Refunded</span>
        <span>{{ item?.total | currency:'USD' }}</span>
      </p>
    </div>
  </ng-template>
 